import React from 'react'
import './Comments.css'
import profilePic from '../../Assets/profilePic.png'
import greenUnderline from '../../Assets/greenUnderline.png'

const CommentCard = ({ comment, name, pic }) => {
    return (
        <div className="commentCardContainer">
            <p className="comment">
                {comment}
            </p>
            <div className="commenter">
                <img src={pic} alt="" />
                {name}
            </div>
        </div>
    )
}

export let CommentSlider = () => {
    return (
        <div className="sliderParent">
            <div className="leftFade"></div>
            <div className="rightFade"></div>
            <div className="sliderContainer1">
                <div className="commentSlider1">
                    <div className="commentHolder1">
                        <CommentCard comment={comment} name={name} pic={profilePic} />
                        <CommentCard comment={comment} name={name} pic={profilePic} />
                        <CommentCard comment={comment} name={name} pic={profilePic} />
                        <CommentCard comment={comment} name={name} pic={profilePic} />
                        <CommentCard comment={comment} name={name} pic={profilePic} />
                        <CommentCard comment={comment} name={name} pic={profilePic} />
                    </div>
                    <div className="commentHolder1">
                        <CommentCard comment={comment} name={name} pic={profilePic} />
                        <CommentCard comment={comment} name={name} pic={profilePic} />
                        <CommentCard comment={comment} name={name} pic={profilePic} />
                        <CommentCard comment={comment} name={name} pic={profilePic} />
                        <CommentCard comment={comment} name={name} pic={profilePic} />
                        <CommentCard comment={comment} name={name} pic={profilePic} />
                    </div>
                </div>
            </div>

            <div className="sliderContainer2">
                <div className="commentSlider2">
                    <div className="commentHolder2">
                        <CommentCard comment={comment} name={name} pic={profilePic} />
                        <CommentCard comment={comment} name={name} pic={profilePic} />
                        <CommentCard comment={comment} name={name} pic={profilePic} />
                        <CommentCard comment={comment} name={name} pic={profilePic} />
                        <CommentCard comment={comment} name={name} pic={profilePic} />
                        <CommentCard comment={comment} name={name} pic={profilePic} />
                    </div>
                    <div className="commentHolder2">
                        <CommentCard comment={comment} name={name} pic={profilePic} />
                        <CommentCard comment={comment} name={name} pic={profilePic} />
                        <CommentCard comment={comment} name={name} pic={profilePic} />
                        <CommentCard comment={comment} name={name} pic={profilePic} />
                        <CommentCard comment={comment} name={name} pic={profilePic} />
                        <CommentCard comment={comment} name={name} pic={profilePic} />
                    </div>
                </div>
            </div>
        </div>
    )
}

let comment = "Our chatbot simplifies medication management. It sends timely reminders for your meds and assists with prescription refills. No more missed doses or rushed pharmacy trips. Enjoy hassle-free healthcare support";
let name = "Kausik dey"

const Comments = () => {
    return (
        <div className='commentsContainer'>
            <h2 className="commentsHeading">Trusted by 2000+ People <img src={greenUnderline} alt="" /></h2>

            <CommentSlider />

        </div>
    )
}

export default Comments